import { createVNode as _createVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, renderSlot as _renderSlot, toDisplayString as _toDisplayString, withCtx as _withCtx, createSlots as _createSlots, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-50b39eb8")

_pushScopeId("data-v-50b39eb8")
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "appointment-type" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "-medium" }, " 진료유형 선택 ", -1)
const _hoisted_4 = { class: "appointment-type-list" }
const _hoisted_5 = { class: "appointment-type-card" }
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "type-card__inner" }, [
  /*#__PURE__*/_createVNode("span", { class: "type-card__icon" }, [
    /*#__PURE__*/_createVNode("svg", {
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, [
      /*#__PURE__*/_createVNode("rect", {
        x: "3",
        y: "5",
        width: "18",
        height: "16",
        rx: "2"
      }),
      /*#__PURE__*/_createVNode("path", { d: "M16 3v4M8 3v4M3 10h18M9 15l2 2 4-4" })
    ])
  ]),
  /*#__PURE__*/_createVNode("span", { class: "type-card__text" }, [
    /*#__PURE__*/_createVNode("strong", null, "진료 예약"),
    /*#__PURE__*/_createVNode("span", null, "병원 방문 진료")
  ]),
  /*#__PURE__*/_createVNode("span", { class: "type-card__check" })
], -1)
const _hoisted_7 = { class: "appointment-type-card" }
const _hoisted_8 = /*#__PURE__*/_createVNode("span", { class: "type-card__inner" }, [
  /*#__PURE__*/_createVNode("span", { class: "type-card__icon" }, [
    /*#__PURE__*/_createVNode("svg", {
      viewBox: "0 0 24 24",
      fill: "currentColor"
    }, [
      /*#__PURE__*/_createVNode("path", { d: "M3 6h12a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1zm14 4.5 4-2.5v8l-4-2.5z" })
    ])
  ]),
  /*#__PURE__*/_createVNode("span", { class: "type-card__text" }, [
    /*#__PURE__*/_createVNode("strong", null, "비대면 진료"),
    /*#__PURE__*/_createVNode("span", null, "화상으로 진료")
  ]),
  /*#__PURE__*/_createVNode("span", { class: "type-card__check" })
], -1)
const _hoisted_9 = {
  key: 0,
  class: "facility-list"
}
const _hoisted_10 = {
  key: 0,
  class: "filters"
}
const _hoisted_11 = {
  key: 0,
  class: "-medium"
}
const _hoisted_12 = {
  key: 0,
  class: "count-mydoctor"
}
const _hoisted_13 = {
  key: 0,
  class: "doctor-list"
}
const _hoisted_14 = {
  key: 1,
  class: "doctor-list__empty view-card"
}
const _hoisted_15 = { class: "p-dialog-title" }
const _hoisted_16 = { class: "-royalBlue" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_DoctorItemOptions = _resolveComponent("DoctorItemOptions")
  const _component_Paginator = _resolveComponent("Paginator")
  const _component_OrderList = _resolveComponent("OrderList")
  const _component_Alert = _resolveComponent("Alert")

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.isOnlineCareRequest)
      ? (_openBlock(), _createBlock("section", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _hoisted_3,
            _createVNode("div", _hoisted_4, [
              _createVNode("label", _hoisted_5, [
                _withDirectives(_createVNode("input", {
                  type: "radio",
                  name: "appointmentType",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedAppointmentType = $event)),
                  onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onCheckedAppointmentType && _ctx.onCheckedAppointmentType(...args))),
                  value: "1"
                }, null, 544), [
                  [_vModelRadio, _ctx.selectedAppointmentType]
                ]),
                _hoisted_6
              ]),
              _createVNode("label", _hoisted_7, [
                _createVNode("input", {
                  type: "radio",
                  name: "appointmentType",
                  onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onCheckedAppointmentType && _ctx.onCheckedAppointmentType(...args))),
                  value: "2"
                }, null, 32),
                _hoisted_8
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode("section", null, [
      (!_ctx.notSelectable)
        ? (_openBlock(), _createBlock("div", _hoisted_9, [
            _createVNode(_component_Dropdown, {
              modelValue: _ctx.selectedFacilityKey,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectedFacilityKey = $event)),
              options: _ctx.filteredFacilityList,
              optionLabel: "FacilityName",
              optionValue: "FacilityKey",
              placeholder: _ctx.t('Select a hospital'),
              showClear: true,
              onChange: _ctx.onChangedRequestingFacility,
              class: "select facility"
            }, null, 8, ["modelValue", "options", "placeholder", "onChange"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode("section", null, [
      true
        ? (_openBlock(), _createBlock("div", _hoisted_10, [
            (_ctx.$slots.title && _ctx.isVisibleDoctorList)
              ? (_openBlock(), _createBlock("div", _hoisted_11, [
                  _renderSlot(_ctx.$slots, "title", {}, undefined, true),
                  (_ctx.notSelectable)
                    ? (_openBlock(), _createBlock("span", _hoisted_12, "(" + _toDisplayString(_ctx.countMyDoctor) + ")", 1))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (!!_ctx.props.isEditable)
              ? (_openBlock(), _createBlock(_component_Dropdown, {
                  key: 1,
                  modelValue: _ctx.depts.select,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.depts.select = $event)),
                  options: _ctx.depts.displayList,
                  optionLabel: "DeptName",
                  optionValue: "DeptKey",
                  placeholder: _ctx.t('filtered by dept'),
                  showClear: true,
                  class: "dept filter"
                }, null, 8, ["modelValue", "options", "placeholder"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.isVisibleDoctorList)
      ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
          (_ctx.displayList && _ctx.displayList.length > 0)
            ? (_openBlock(), _createBlock("section", _hoisted_13, [
                _createVNode(_component_OrderList, {
                  modelValue: _ctx.displayList,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.displayList = $event)),
                  listStyle: _ctx.isHeightLimit ? 'height:40vh' : '',
                  dataKey: "DoctorKey",
                  "onUpdate:selection": _ctx.onUpdateSelection,
                  selection: _ctx.doctor.selectedDoctor,
                  class: _ctx.isNotSelectable ? 'not-selectable' : 'selectable'
                }, _createSlots({
                  item: _withId((slotProps) => [
                    (!!slotProps.item)
                      ? (_openBlock(), _createBlock(_component_DoctorItemOptions, {
                          key: 0,
                          doctor: slotProps.item,
                          isFavorit: true,
                          onToggleFavorit: _ctx.onToggleFavorites
                        }, null, 8, ["doctor", "onToggleFavorit"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, [
                  (_ctx.doctor.selectedPage > 1)
                    ? {
                        name: "footer",
                        fn: _withId(() => [
                          _createVNode(_component_Paginator, {
                            first: _ctx.doctor.selectedPage,
                            "onUpdate:first": _cache[6] || (_cache[6] = ($event: any) => (_ctx.doctor.selectedPage = $event)),
                            totalRecords: _ctx.doctor.selectedPage.valueOf(),
                            rows: 1
                          }, null, 8, ["first", "totalRecords"])
                        ])
                      }
                    : undefined
                ]), 1032, ["modelValue", "listStyle", "onUpdate:selection", "selection", "class"])
              ]))
            : (_openBlock(), _createBlock("section", _hoisted_14, [
                _createVNode("p", null, _toDisplayString(_ctx.t("there is no selectable doctors")), 1)
              ]))
        ], 64))
      : _createCommentVNode("", true),
    (!!_ctx.alert.content)
      ? (_openBlock(), _createBlock(_component_Alert, {
          key: 2,
          alert: _ctx.alert,
          "onUpdate:alert": _cache[8] || (_cache[8] = ($event: any) => (_ctx.alert = $event)),
          isConfirm: true,
          "onUpdate:clear": _cache[9] || (_cache[9] = ($event: any) => (_ctx.alert.content = ''))
        }, {
          title: _withId(() => [
            _createVNode("span", _hoisted_15, [
              _createVNode("span", _hoisted_16, _toDisplayString(_ctx.t("added doctor to favorite doctror", { name: _ctx.selectMyDoctorName })), 1)
            ])
          ]),
          _: 1
        }, 8, ["alert"]))
      : _createCommentVNode("", true)
  ], 64))
})